import { styled } from "@mui/material/styles";
import { Drawer } from "@mui/material";

const StyledDrawer = styled(Drawer)<{ width?: string }>`
  & .MuiModal-backdrop {
    background-color: rgba(82, 90, 106, 0.4);
  }

  & .MuiPaper-root {
    padding: 30px 0;
    box-sizing: border-box;
    min-width: 300px;
    ${({ width }) => width && `width: ${width}`};
    background-color: ${({ theme }) => theme.palette.common.white};

    @media (min-width: 1024px) {
      min-width: 564px;
    }
  }
`;

const StyledDrawerHeader = styled("div")<{ withBackBtn?: boolean }>`
  width: 100%;
  display: flex;
  padding: 0 16px;
  box-sizing: border-box;
  align-items: center;
  justify-content: ${({ withBackBtn }) =>
    withBackBtn ? "space-between" : "flex-end"};
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    padding: 0 32px;
  }

  & .drawer-close {
    color: ${({ theme }) => theme.palette.customGrey.dark};
    transition: all 0.2s linear;

    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
      transition: all 0.2s linear;
    }
  }
`;

const StyledDrawerContent = styled("div")<{
  overflow?: "hidden" | "visible" | "auto";
}>`
  width: 100%;
  height: 100%;
  overflow: ${({ overflow }) => overflow ?? "auto"};
  padding: 0 16px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    padding: 0 32px;
  }
`;

export { StyledDrawer, StyledDrawerHeader, StyledDrawerContent };
